import React, { Component } from 'react';
import './App.css';
import links_list from './List';

class Link extends Component {
  render() {
    const link = this.props.link;
    const [url, n_copies, year, title, domain] = link.split(';');
    return (
      <div className="Link">
        <div className="id">{this.props.index}</div>
        <div className="rightPart">
          <div className="title">
            <a href={url}>{title}</a> ({domain})
          </div>
          <div className="info">Posted {n_copies} times, created in {year}</div>
        </div>
      </div>
    );
  }
}

class LinksList extends Component {
  render() {
    const links = this.props.links;
    return (
      <div className="LinksList">
        {links.map((link, id) => <Link link={link} key={id} index={id} />)}
      </div>
    );
  }
}

class App extends Component {
  render() {
    return (
      <div className="App">
        <h1 className="header">
          Classic HN links
        </h1>
        <p className="projectDescription">
          These are 1000 “classic” links from <a href="https://news.ycombinator.com">news.ycombinator.com</a>.
          I took all HN submissions that got at least 30 upvotes,
          chose those that were posted at least twice, and then sorted them
          by the number of times submitted and their inflation-adjusted scores.
          Created by <a href="https://twitter.com/posobin">@posobin</a>,
          check out my <a href="http://posobin.com">homepage</a>.
          I am in San Francisco until January 16th, DM me to meet up over a coffee!
        </p>
        <LinksList links={links_list} />
      </div>
    );
  }
}

export default App;
